import Styles from './styles.module.css';
import React, { useState } from 'react';
import ErrorMessage from '../../../package/error/index';
import DefaultInput1 from '../../../package/1-input/index';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { numberData } from 'src/type';

type RecruitNumber = {
  documentId: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  number: numberData;
  setNumber: React.Dispatch<React.SetStateAction<numberData>>;
};

const RecruitNumber: React.FC<RecruitNumber> = ({ documentId, setChangeData, number, setNumber }) => {

  type FieldConfig = {
    label: string;
    key: keyof numberData;
    unit: string;
    length: number;
  };

  const FIELD_CONFIGS: FieldConfig[] = [
    { label: '創業から', key: 'text1', unit: '年', length: 3 },
    { label: '平均勤続年数', key: 'text2', unit: '年', length: 2 },
    { label: '店舗数', key: 'text3', unit: '店舗', length: 3 },
    { label: '男女比', key: 'text4', unit: '〇:〇', length: 4 },
    { label: '採用人数', key: 'text5', unit: '人', length: 3 },
    { label: '最短デビュー', key: 'text6', unit: 'ヶ月', length: 2 },
    { label: '平均顧客単価', key: 'text7', unit: '千円', length: 3 },
    { label: 'アシスタント給与', key: 'text8', unit: '万円', length: 4 },
    { label: '引越し金', key: 'text9', unit: '万円', length: 2 },
    { label: '平均年齢', key: 'text10', unit: '歳', length: 2 },
    { label: 'リピート率', key: 'text11', unit: '%', length: 2 },
    { label: 'コンテスト受賞数', key: 'text12', unit: '回', length: 2 },
    { label: '地方出身者割合', key: 'text13', unit: '%', length: 3 },
  ];

  const [ errorMessage, setErrorMessage ] = useState('');
  const [ banner, setBanner ] = useState<boolean>(false);

  function validateCompanyData(data: numberData): string | null {
    if (data.tags.length < 4) return '項目を4つ選択してください。';

    for (const field of FIELD_CONFIGS) {
      if (data.tags.includes(field.label) && !data[field.key]) {
        return `${field.label}を入力してください。`;
      }
    }

    return null;
  }

  function check() {
    setErrorMessage('');
    window.scrollTo(0, 0);
    const error = validateCompanyData(number);
    if (error) {
      setErrorMessage(error);
      return;
    }
    save(true);
  }

  const [ uploading, setUploading ] = useState(false);

  const save = async (isCompleted: boolean) => {
    setUploading(true);

    let ok = false;

    try {
      const ref = doc(getFirestore(), "recruits", documentId);

      const dataToSend = {
        ...number,
        isCompleted,
        time: new Date(),
      };

      await updateDoc(ref, { number: dataToSend });

      setChangeData(false);
      ok = true;

    } catch (error) {
      console.error("🔥 保存に失敗:", error);
      setErrorMessage('保存に失敗しました。時間をおいてもう一度お試しください。');
    } finally {
      setUploading(false);
      // 保存できたときだけ「保存しました」を出す(失敗時に出ていたバグの修正)。
      if (ok) {
        setBanner(true);
        setTimeout(() => { setBanner(false); }, 1500);
      }
    }
  };

  var スタイル = [
    '創業から',
    '平均勤続年数',
    '店舗数',
    '男女比',
    '採用人数',
    '最短デビュー',
    '平均顧客単価',
    'アシスタント給与',
    '引越し金',
    '平均年齢',
    'リピート率',
    'コンテスト受賞数',
    '地方出身者割合',
  ]
  
  return (
    <>
    {errorMessage !== '' ? <ErrorMessage message={errorMessage} /> : <></> }
    {banner && <div className={Styles.banner}>保存しました。</div>}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>数字で店舗を表現（4個）</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => check()}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>

      <p className={Styles.numberHint}>
        表示したい項目を4つ選択してください。チェックした項目の入力欄が下に表示されます。
      </p>

      <div className={Styles.numberTag}>
        {FIELD_CONFIGS.map((field) => (
          <div key={field.label}>
            <input
              type="checkbox"
              checked={number.tags.includes(field.label)}
              onChange={(e) => {
                setNumber(prev => {
                  const tags = prev.tags;

                  if (e.target.checked) {
                    if (tags.includes(field.label) || tags.length >= 4) return prev;
                    return { ...prev, tags: [...tags, field.label] };
                  } else {
                    return { ...prev, tags: tags.filter(v => v !== field.label) };
                  }
                });
              }}
            />
            <p>{field.label}</p>
          </div>
        ))}
      </div>

    </div>


    <div className={Styles.test_box}>

      {number.tags.length === 0 ? (
        <p className={Styles.numberEmpty}>
          上の項目にチェックを入れると、ここに入力欄が表示されます。
        </p>
      ) : (
        FIELD_CONFIGS
          .filter(field => number.tags.includes(field.label))
          .map(field => (
            <DefaultInput1
              key={field.key}
              error={false}
              title={`${field.label}(${field.unit}) ※`}
              length={field.length}
              place=""
              value={number[field.key] as string}
              setValue={(val: string) => {
                setNumber(prev => ({
                  ...prev,
                  [field.key]: val,
                }));
                setChangeData(true);
              }}
              desc=""
              hint={{ title: "", desc: "" }}
            />
          ))
      )}

    </div>

    </>
  );
}

export default RecruitNumber;
